module.exports = __webpack_public_path__ + "static/media/home_7.46731aa6.jpg";